import compactEmojis from 'emojibase-data/en/compact.json';
import shortcodes from 'emojibase-data/en/shortcodes/iamcal'; // NOTE: iamcal is the shortcodes that Slack uses

export default compactEmojis
  // Only include emojis that have an associated shortcode
  .filter((e) => shortcodes[e.hexcode])
  // include the shortcode
  .map((e) => ({
    ...e,
    shortcode: shortcodes[e.hexcode],
    // Replace the `xp` emoticon with `xP`
    emoticon: e.emoticon === 'xp' ? 'xP' : e.emoticon,
  }))
  // Some emojis have `skins`. We want to include the base emoji and all of the skin tones.
  .flatMap((e) =>
    e.skins
      ? [
          e,
          ...e.skins.map((s) => ({
            ...s,
            // If the skin tone doesn't have a shortcode, then we'll default to the shortcode of the parent emoji
            shortcode: shortcodes[e.hexcode] || e.shortcode,
          })),
        ]
      : [e]
  )
  // Some emojis have more than one shortcode specified. We want to include of the shortcodes.
  .flatMap((e) => (Array.isArray(e.shortcode) ? e.shortcode.map((shortcode) => ({ ...e, shortcode })) : [e]))
  // Trim down the object to just the properties that we care about
  .map(({ hexcode, emoticon, shortcode, unicode }) => ({
    hexcode,
    shortcode,
    emoticon,
    unicode,
  }));
